<template>
  <div id="app" onselectstart="return false;">
    <!-- 顶部 -->
    <div class="header">
      <!-- logo -->
      <div class="logo">
        <img src="./assets/home/logo.png" alt="" />
      </div>
      <!-- 导航栏和搜索框 -->
      <div class="header-right">
        <!-- 导航栏 -->
        <div class="header-menu">
          <div
            class="menu-box"
            v-for="(item, index) in navList"
            :key="index"
            @click="routerurl(index, item.path)"
            @mouseover="hover(index)"
            @mouseout="mouseOut()"
          >
            <p
              :class="
                activeIndex == index || hoverIndex == index ? 'fontColor' : ''
              "
            >
              {{ item.name }}
            </p>
            <transition name="fade">
              <img
                v-show="activeIndex == index || hoverIndex == index"
                src="./assets/home/line.png"
                alt=""
              />
            </transition>
          </div>
        </div>
        <!-- 搜索框 -->
        <div class="serach" @click="searchClick()">
          <img src="./assets/home/serach.png" alt="" />
          <input type="text" class="serach-input" />
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view class="view"></router-view>
    </keep-alive>
    <!-- 联系我们 -->
    <div class="link" v-show="linkShow">
      <div class="linkus">
        <!-- 标题 -->
        <div class="title">留下你的联系方式，我们尽快跟您联系</div>
        <!-- 取消按钮 -->
        <img
          @click="cancelClick()"
          class="cancelimg"
          src="./assets/home/cancel.png"
          alt=""
        />
        <!-- 姓名信息  -->
        <div class="info">
          <div class="label">
            <span>姓名</span>
            <img src="./assets/home/star.png" alt="" />
          </div>
          <div class="input">
            <el-input
              style="width: 520px"
              placeholder="请输入你的姓名"
              v-model="name"
              maxlength="20"
            >
            </el-input>
          </div>
        </div>
        <!-- 电话信息 -->
        <div class="info">
          <div class="label">
            <span>电话</span>
            <img src="./assets/home/star.png" alt="" />
          </div>
          <div class="input">
            <el-input
              style="width: 520px"
              type="tel"
              placeholder="请输入你的电话"
              v-model="phone"
              maxlength="11"
            >
            </el-input>
          </div>
        </div>
        <!-- 邮箱信息 -->
        <div class="info">
          <div class="label">
            <span>邮箱</span>
            <img src="./assets/home/star.png" alt="" />
          </div>
          <div class="input">
            <el-input
              style="width: 520px"
              type="emial"
              placeholder="请输入你的邮箱"
              v-model="email"
            >
            </el-input>
          </div>
        </div>
        <!-- 反馈信息 -->
        <div class="info">
          <div class="label">
            <span>反馈</span>
            <img src="./assets/home/star.png" alt="" />
          </div>
          <div class="input">
            <el-input
              type="textarea"
              size="medium"
              style="width: 520px"
              maxlength="120"
              placeholder="请输入你的建议或者问题"
              v-model="feedback"
              :autosize="{ minRows: 4, maxRows: 6 }"
            >
            </el-input>
          </div>
        </div>
        <!-- 立即提交按钮 -->
        <div class="sbmitBtn" @click="sbmitClick()">立即提交</div>
      </div>
    </div>
    <!-- 悬浮图标 -->

    <div class="hoverImg">
      <div
        @mouseover="askhover()"
        @mouseout="askmouseOut()"
        @click="phoneClick()"
      >
        <img
          v-show="askShow"
          class="hover-imgs"
          src="./assets/home/phone.png"
          alt=""
        />
        <div v-show="!askShow" class="font">在线咨询</div>
      </div>

      <div class="hover-line"></div>
      <div
        @mouseover="tophover()"
        @mouseout="topmouseOut()"
        @click="backTOPClick()"
      >
        <img
          v-show="topShow"
          class="hover-imgs"
          src="./assets/home/backtop.png"
          alt=""
        />
        <div class="font" v-show="!topShow">返回置顶</div>
      </div>
    </div>
    <!-- 尾部 -->
    <div class="footer">
      <!-- 版权所有 -->
      <div class="copyright">
        <div>
          <p>版权所有：杭州雅格新创科技有限公司
            <a style="color:#fff" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2020042328号</a>
          </p>
          <p>
            Copyright © 2016 Yusys Technologies Co., Ltd. All Rights Reserved.
          </p>
        </div>
      </div>

      <!-- 产品与解决方案 -->
      <div class="product">
        <p class="title">产品与解决方案</p>
        <p class="content" @click="routerurl(1, '/BI')">
          大数据BI商业智能解决方案
        </p>
        <p class="content" @click="routerurl(1, '/RPA')">RPA智能解决方案</p>
        <p class="content" @click="routerurl(1, '/bank')">智能银行解决方案</p>
        <p class="content" @click="routerurl(1, '/risk')">
          大数据智能风控解决方案
        </p>
        <p class="content" @click="routerurl(1, '/visual')">
          数据可视化解决方案
        </p>
        <!-- 售前 -->
        <p class="pre-sales">售前：0571-8608626</p>
      </div>
      <!-- IT服务 -->
      <div class="IT">
        <p class="title">IT服务</p>
        <p class="content">咨询服务</p>
        <p class="content">应用开发服务</p>
        <p class="content">测试服务</p>
        <p class="content">运营服务</p>
        <!-- 售后 -->
        <!-- <p class="after-sales">售后：4008071288</p> -->
      </div>
      <!-- 快速链接 -->
      <div class="link">
        <p class="title">快速链接</p>
        <p class="content" @click="routerurl(4, '/aboutyage')">关于雅格</p>
        <p class="content" @click="routerurl(5, '/jionYG')">加入雅格</p>
        <p class="content" @click="routerurl(3, '/news')">新闻动态</p>
        <p class="content">联系我们</p>
        <!-- 邮箱 -->
        <p class="email">邮箱：tech@hzyage.onaliyun.com</p>
      </div>
      <!-- 二维码 -->
      <div class="code">
        <img src="./assets/home/code.png" alt="" />
        <p>官方公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      transitionName: "",
      // 导航栏的选择
      activeIndex: sessionStorage.getItem("activeIndex")
        ? sessionStorage.getItem("activeIndex")
        : 0,
      hoverIndex: -1,
      // 搜索内容
      serachContent: "",
      navList: [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "产品与解决方案",
          path: "/productAndsolve",
        },
        {
          name: "IT服务",
          path: "/it",
        },
        {
          name: "新闻动态",
          path: "/news",
        },
        {
          name: "关于雅格",
          path: "/aboutyage",
        },
        {
          name: "加入雅格",
          path: "/jionYG",
        },
      ],
      // 联系我们页面是否展示
      linkShow: false,
      // 姓名
      name: "",
      // 电话
      phone: "",
      // 邮箱
      email: "",
      // 反馈
      feedback: "",
      // 咨询图标是否显示
      askShow: true,
      // 置顶图标是否显示
      topShow: true,
    };
  },
  components: {},

  mounted() {},
  methods: {
    // 搜索框跳转
    searchClick(){
      this.$router.push('/search')
    },
    // 跳转页面
    routerurl(i, path) {
      this.activeIndex = i;
      this.$router.push(path);
      sessionStorage.setItem("activeIndex", i);
    },

    // 导航栏鼠标放置
    hover(i) {
      this.hoverIndex = i;
    },
    // 导航栏鼠标离开
    mouseOut() {
      this.hoverIndex = -1;
    },
    // 点击取消按钮
    cancelClick() {
      this.linkShow = false;
    },
    // 立即提交按钮
    sbmitClick() {
      // 参数
      var param = {
        name: this.name,
        phoneNumber: this.phone,
        email: this.email,
        question: this.feedback,
      };
      var telTest = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      var emailTest = /^\w+@[a-z0-9]+\.[a-z]{2,4}$/;
      
      if (
        this.name == "" ||
        this.phone == "" ||
        this.email == "" ||
        this.feedback == ""
      ) {
        this.$message({
          message: "请填写完整信息",
          type: "error",
        });
      } 
      else if (!telTest.test(this.phone)) {
        console.log(telTest.test(this.phone));
        this.$message({
          message: "请填写正确的手机号码",
          type: "error",
        });
      } else if (!emailTest.test(this.email)) {
        this.$message({
          message: "请填写正确的邮箱号",
          type: "error",
        });
      } 
      else {
        this.$post("/info", param)
          .then((res) => {
            console.log(res);
            if (res.data.success == true) {
              console.log("成功");
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.linkShow = false;
            } else {
              this.$message({
                message: "提交失败",
                type: "error",
              });
            }
          })
          .catch(() => {
            this.$message({
                message: "提交失败",
                type: "error",
              });
          });
      }
    },
    // 在线咨询图标
    phoneClick() {
      this.linkShow = true;
    },
    // 在线咨询鼠标悬浮
    askhover() {
      this.askShow = false;
    },
    // 在线咨询鼠标移走
    askmouseOut() {
      this.askShow = true;
    },
    // 置顶图标
    backTOPClick() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    // 置顶鼠标悬浮
    tophover() {
      this.topShow = false;
    },
    // 置顶鼠标移走
    topmouseOut() {
      this.topShow = true;
    },
  },
  watch: {
    // 使用watch 监听$router的变化
    $route(to, from) {
      // console.log(to);
      // 如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        // 设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
#app {
  min-width: 1200px;
  min-height: 700px;
  margin: 0 auto;
   // 图片不模糊
  image-rendering:-moz-crisp-edges;
  image-rendering: -o-crisp-edges; 
  image-rendering: -webkit-optimize-contrast; 
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor; 
  // cursor: pointer;
  .header {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    background: #ffffff;
    position: sticky;
    top: 0;
    z-index: 999;
    cursor: pointer;
    // logo
    .logo img {
      width: 200px;
      height: 35px;
      margin: 25px 0;
    }
    .header-right {
      display: flex;
      justify-content: center;
      // 导航栏
      .header-menu {
        margin: 10px 40px 0;
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        display: flex;
        flex-wrap: nowrap;
        .menu-box {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;

          text-align: center;
          margin: 20px auto -10px;
          .fontColor {
            color: #377eff;
          }
          p {
            margin: 0 20px 10px;
            color: #808080;
          }
          P:hover {
            color: #377eff;
          }
          .fade-enter-active {
            width: 80px;
            height: 4px;
            transition: all 0.5s; //类名：隐藏到显示过程所需要的时间
          }
          .fade-enter {
            // 类名:初始化状态
            width: 0px;
            height: 0px;
          }
          img {
            width: 80px;
            height: 4px;
            margin-bottom: -5px;
          }
        }
      }
      // 搜索框
      .serach {
        margin: 25px 0;
        width: 201px;
        height: 30px;
        background: #ffffff;
        border: 2px solid #e6e6e6;
        border-radius: 28px;
        position: relative;
        // 搜索图片
        img {
          width: 20px;
          height: 20px;
          position: absolute;
          top: 5px;
          left: 10px;
        }
        // 搜索框input
        .serach-input {
          width: 161px;
          height: 26px;
          border: none;
          position: absolute;
          top: 0;
          left: 30px;
        }
        // input选中后的样式
        input[type="text"]:focus {
          outline: none;
          border: 1px solid #fff;
        }
      }
    }
  }
  .view {
    width: 100%;
    margin: 0 auto;
  }
  // 联系我们
  .linkus {
    margin: 0 auto;
    background: #ffffff;
    box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.07);
    border-radius: 10px;
    padding-bottom: 20px;
    box-sizing: border-box;
    width: 730px;
    margin: 0 auto;
    background: #ffffff;
    position: fixed;
    top: 200px;
    left: calc(50% - 375px);
    z-index: 99;
    // 标题
    .title {
      width: 730px;
      height: 86px;
      background: #f5f5f5;
      border-radius: 10px;
      text-align: center;
      line-height: 86px;
      color: #292929;
      font-size: 25px;
    }
    // 取消按钮
    .cancelimg {
      position: absolute;
      top: 33px;
      right: 45px;
      width: 23px;
      height: 23px;
    }
    // 反馈信息
    .info {
      display: flex;
      margin: 30px 0;
      .label {
        margin: 5px 20px 0 55px;
        color: #292929;
        font-size: 20px;
        position: relative;
        img {
          position: absolute;
        }
      }
    }
    // 立即提交按钮
    .sbmitBtn {
      width: 556px;
      height: 60px;
      background: linear-gradient(90deg, #155ee4 0%, #19b4fe 100%);
      border-radius: 6px;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
      line-height: 60px;
      margin: 60px auto 40px;
    }
  }
  // 悬浮图标
  .hoverImg {
    width: 73px;
    background: #ffffff;
    box-shadow: 0px 0px 35px 0px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    position: fixed;
    right: 30px;
    top: 300px;
    z-index: 999;
    padding: 15px;
    box-sizing: border-box;
    // 图标
    .hover-imgs {
      width: 41px;
      height: 40px;
    }
    // 文字描述
    .font {
      width: 50px;
      color: #999999;
      font-size: 18px;
      margin-left: 5px;
      cursor: pointer;
    }
    // 横线
    .hover-line {
      width: 45px;
      height: 1px;
      background: #bfbfbf;
      margin: 20px auto;
    }
  }
  // 底部
  .footer {
    width: 100%;
    margin: 0 auto;
    height: 350px;
    position: relative;
    background-image: url("./assets/home/bottom.jpg");
    background-size: 100% 100%;
    cursor: pointer;
    // 版权所有
    .copyright {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      position: absolute;
      bottom: 10%;
      left: 10%;
      display: flex;
    }
    // 产品与解决方案
    .product {
      position: absolute;
      top: 20px;
      left: 45%;
      .content:hover {
        color: #377eff;
      }
    }
    // IT服务
    .IT {
      position: absolute;
      top: 20px;
      left: 62%;
    }
    // 快速连接
    .link {
      position: absolute;
      top: 20px;
      left: 72%;
      .content:hover {
        color: #377eff;
      }
    }
    // 标题
    .title {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      margin: 20px auto;
    }
    // 内容
    .content {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #919499;
      line-height: 30px;
    }
    // 售前
    .pre-sales {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      text-decoration: underline;
      color: #919499;
      margin-top: 20px;
    }
    // 售后
    .after-sales {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      text-decoration: underline;
      color: #919499;
      margin-top: 50px;
    }
    // 邮箱
    .email {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      text-decoration: underline;
      color: #919499;
      margin-top: 50px;
    }
    // 公众号
    .code {
      position: absolute;
      top: 50px;
      right: 10%;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #919499;
      p {
        margin-left: 4px;
      }
    }
  }
}
</style>
